import request from "@/utils/request";
// import cookies from "js-cookie";
// import checkThereIsQuery from "@/helpers/checkQuery";
import convertQuery from "@/utils/buildQuery";

export function index(reqName, query = {}) {
  return request({
    url: `${reqName}?a&${convertQuery(query)}`,
    // headers: { "X-locale": locale ? locale : cookies.get("language") },
    method: "get"
  });
}
export function indexQuery(reqName, query = {}) {
  return request({
    url: `${reqName}${convertQuery(query)}`,
    // headers: { "X-locale": locale ? locale : cookies.get("language") },
    method: "get"
  });
}

export function showData(reqName, slug, query) {
  return request({
    // url: `${reqName}/${slug}?a`,
    url: `${reqName}${slug ? `/${slug}` : ""}?a`,
    // headers: { "X-locale": locale },
    method: "get",
    params: {
      ...query
    }
  });
}

export function storeData(reqName, data) {
  return request({
    url: `${reqName}`,
    method: "post",
    data
  });
}
export function exportData(reqName, data) {
  return request({
    url: `${reqName}`,
    // headers: {
    //   "Content-Type":
    //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    //   Accept: "application/vnd.api+json",
    //   "X-Locale": "en"
    // },
    method: "post",
    data
  });
}
export const updateData = (reqName, data, id) => {
  return request({
    url: `${reqName}/${id}`,
    method: "post",
    data
  });
};
export function deleteData(reqName, id) {
  return request({
    url: `${reqName}/${id}`,
    method: "delete"
  });
}
export function mediaUpdate(id, data) {
  return request({
    url: `media/${id}`,
    method: "post",
    data
  });
}
